// extracted by mini-css-extract-plugin
export default {"svgIcon":"NWbzO6OS"};